// Marking a preparer's edit of an AI-written note (28 Oct 2026).
//
// AI notes are stamped with the figures they quote and are replaced at generation if those figures change
// (backend note_guard.stale_notes). Without a record that the PREPARER changed the wording, their own text
// could be overwritten by that replacement. A note whose text differs from what the AI wrote is flagged
// `edited`; the backend never judges or replaces an edited note.
const norm = (t) => String(t || '').replace(/\s+/g, ' ').trim()

export const withEditedText = (note, text) => {
  const n = note || {}
  const changed = norm(text) !== norm(n.text)
  return { ...n, text, ...(changed && n.source === 'ai' ? { edited: true } : {}) }
}
